import React, { useEffect } from 'react';
import {
  LayoutElementState,
  useLayoutContext,
  BREAKPOINT_FOR_RIGHT_RAIL_COVER,
} from '../../context/LayoutContext';
import useBreakpointStatus from '../../hooks/useBreakpointStatus';
import InlineRightRail from './InlineRightRail';
import LayeredRightRail from './LayeredRightRail';

export const RIGHT_RAIL_WIDTH = 270;
export const RIGHT_RAIL_WIDTH_COLLAPSED = 0;

export interface RightRailProps {
  children?: React.ReactNode;
}

/**
 * @description A layout component for the Right Rail that renders either the layered or inline
 *  right rail or null if the rail should be hidden.
 *
 * Given a breakpoint to cover at, this component will dynamic render the layered
 *  rail if the screen's resolution is at or below the given bp, and render the inline rail if
 *  the screen's resolution is above the given bp.
 */
export default function RightRail({ children }: RightRailProps) {
  const { setRightRailVisibility, isRightRailHidden } = useLayoutContext();

  useEffect(() => {
    if (!children && !isRightRailHidden) {
      setRightRailVisibility(LayoutElementState.HIDDEN);
    }
  }, [isRightRailHidden, setRightRailVisibility, children]);

  const bpStatus = useBreakpointStatus({
    breakpointToCover: BREAKPOINT_FOR_RIGHT_RAIL_COVER,
  });
  const Wrapper =
    bpStatus && (bpStatus.isAtBreakpoint || bpStatus.isBelowBreakpoint)
      ? LayeredRightRail
      : InlineRightRail;

  return !isRightRailHidden ? <Wrapper>{children}</Wrapper> : null;
}
